module.exports = __webpack_public_path__ + "img/unlink2.2c7e3beb.png";